import { u0 } from './update.0';
import { u1 } from './update.1';
import { u10 } from './update.10';
import { u11 } from './update.11';
import { u12 } from './update.12';
import { u13 } from './update.13';
import { u14 } from './update.14';
import { u15 } from './update.15';
import { u16 } from './update.16';
import { u17 } from './update.17';
import { u18 } from './update.18';
import { u19 } from './update.19';
import { u2 } from './update.2';
import { u20 } from './update.20';
import { u21 } from './update.21';
import { u3 } from './update.3';
import { u4 } from './update.4';
import { u5 } from './update.5';
import { u6 } from './update.6';
import { u7 } from './update.7';
import { u8 } from './update.8';
import { u9 } from './update.9';

export const updates = [
	u0,
	u1,
	u2,
	u3,
	u4,
	u5,
	u6,
	u7,
	u8,
	u9,
	u10,
	u11,
	u12,
	u13,
	u14,
	u15,
	u16,
	u17,
	u18,
	u19,
	u20,
	u21
];
